module.exports = {
  "VisbyRoundCF-DemiBold": require("./VisbyRoundCF-DemiBold.ttf"),
  "VisbyRoundCF-ExtraBold": require("./VisbyRoundCF-ExtraBold.ttf"),
  "VisbyRoundCF-ExtraLight": require("./VisbyRoundCF-ExtraLight.ttf"),
  "VisbyRoundCF-Heavy": require("./VisbyRoundCF-Heavy.ttf"),
  "VisbyRoundCF-Light": require("./VisbyRoundCF-Light.ttf"),
  "VisbyRoundCF-Medium": require("./VisbyRoundCF-Medium.ttf"),
  "VisbyRoundCF-Regular": require("./VisbyRoundCF-Regular.ttf")
};
